import { PfixOneTimePasswordMessage } from '../Messages/PfixOneTimePasswordMessage';
import { MessageProcessorBase } from './MessageProcessorBase';
export class OneTimePasswordMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const msg = new PfixOneTimePasswordMessage(fieldSet);
        return [msg];
    }
}
